import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import { AddCircleBlue, CustomDelete, FullTable, NotError } from 'components';
import { FindErrorItem, Images, useDiagnosisMatchEnabled, useModal } from 'utils';
import { clientDiagnosisActions, httpRequestsOnErrorsActions } from 'store';
import {
    canManageDiagnoses,
    DELETE_DIAGNOSIS_ACTION,
    diagnosesBody,
    diagnosesHead,
    diagnosesNotYet,
    diagnosisActionNames,
    GET_DIAGNOSES_ACTION,
    SET_PRIMARY_DIAGNOSIS_ACTION,
} from './constants';
import { AddDiagnosisModal } from './addDiagnosisModal';

/**
 * Clinical → Diagnoses. The client's diagnosis list is the clinical truth: with diagnosis matching
 * on, appointments and claims bill these codes (filtered by each payer service's accepted list).
 * Shown even while the org switch is off, so an org can enter diagnoses before turning it on.
 */
export const Diagnoses = ({ actionsSlot }) => {
    const dispatch = useDispatch();
    const params = useParams();
    const diagnoses = useSelector((state) => state.clientDiagnosis.clientDiagnoses);
    const diagnosisMatchEnabled = useDiagnosisMatchEnabled();
    const primaryError = FindErrorItem(SET_PRIMARY_DIAGNOSIS_ACTION);
    const { open } = useModal();

    useEffect(() => {
        dispatch(clientDiagnosisActions.getClientDiagnoses(params?.id));
    }, [params?.id]);

    useEffect(() => {
        if (!primaryError?.error) return;
        toast(<NotError type={'error'} errMessage={primaryError.error} />);
        dispatch(httpRequestsOnErrorsActions.removeError(SET_PRIMARY_DIAGNOSIS_ACTION));
    }, [primaryError]);

    const currentPrimary = diagnoses?.find((diagnosis) => diagnosis?.isPrimary);

    const handleClickButton = (item, name) => {
        if (name === diagnosisActionNames.EDIT) {
            open(<AddDiagnosisModal info={item} />);
        } else if (name === diagnosisActionNames.MAKE_PRIMARY) {
            open(
                <CustomDelete
                    info="Change Primary Diagnosis?"
                    text={
                        currentPrimary
                            ? `Setting ${item?.code} as primary will replace ${currentPrimary.code} as the client's primary diagnosis.`
                            : `${item?.code} will become the client's primary diagnosis.`
                    }
                    color={'blue'}
                    innerText={'Set as Primary'}
                    actionType={SET_PRIMARY_DIAGNOSIS_ACTION}
                    handleDel={() => dispatch(clientDiagnosisActions.setPrimaryClientDiagnosis(item?.id, params?.id))}
                />
            );
        } else if (name === diagnosisActionNames.REMOVE) {
            open(
                <CustomDelete
                    info="Remove Diagnosis"
                    text="Are you sure you want to remove this diagnosis? Use an end date instead if the client had it and it has resolved."
                    innerText={'Remove'}
                    actionType={DELETE_DIAGNOSIS_ACTION}
                    handleDel={() => dispatch(clientDiagnosisActions.deleteClientDiagnosis(item?.id, params?.id))}
                    body={
                        <div className="deleting-client-info-box">
                            <img src={Images.client} alt="icon" />
                            <p>{`${item?.code}${item?.description ? ` · ${item.description}` : ''}`}</p>
                        </div>
                    }
                />
            );
        }
    };

    return (
        <div>
            {/* Banner and Add sit on the sub-tab row (design: Single Client – Clinical) */}
            {actionsSlot &&
                createPortal(
                    <>
                        {/*<div className="diagnoses-info-banner">*/}
                        {/*    <img src={Images.infoCircleGray} alt="info" />*/}
                        {/*    <p>*/}
                        {/*        {diagnosisMatchEnabled*/}
                        {/*            ? 'Appts use the diagnoses that are active on the date of service. Billed appts never change.'*/}
                        {/*            : 'Diagnosis matching is off, so claims use the payer service codes.'}*/}
                        {/*    </p>*/}
                        {/*</div>*/}
                        {canManageDiagnoses() && <AddCircleBlue text={'Add Diagnoses'} handleClick={() => open(<AddDiagnosisModal />)} />}
                    </>,
                    actionsSlot
                )}

            <FullTable
                head={diagnosesHead()}
                body={diagnosesBody()}
                loadingType={GET_DIAGNOSES_ACTION}
                list={diagnoses}
                handleClickButton={handleClickButton}
                notYet={diagnosesNotYet}
                margin={'0'}
                minWidth={900}
            />
        </div>
    );
};
